
































































































































import { Component, Ref, Vue, Watch } from 'vue-property-decorator'
import { Inject } from 'inversify-props'
import SeletorDeLojas from '@/components/loja/SeletorDeLojas.vue'
import type { LojaServiceAdapter, MarketplaceServiceAdapter, ThreadsServiceAdapter } from '@/usecases'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import DataTableDeCrud from '@/components/ui/DataTableDeCrud.vue'
import axios, { CancelTokenSource } from 'axios'
import { DataOptions } from 'vuetify'
import { Loja, ProdutoMarketplace } from '@/models'
import { IntegracaoMarketplaceUseCase } from '@/usecases/marketplace/IntegracaoMarketplaceUseCase'
import { dateTimeToPtBrFormat } from '@/shareds/date/date-utils'
import DialogoProdutoMarketplace from '@/components/marketplace/DialogoProdutoMarketplace.vue'
import DialogoDeEdicaoEmMassaProdutosMarketplace from './DialogoDeEdicaoEmMassaProdutosMarketplace.vue'
import { verificarQualidadeDoCadastro } from '@/shareds/marketplace-shareds'
@Component({
	components: {
		SeletorDeLojas,
		DataTableDeCrud,
		DialogoProdutoMarketplace,
		DialogoDeEdicaoEmMassaProdutosMarketplace,
	},
})
export default class TelaDeProdutosMarketplace extends Vue {
	@Ref() dialogoProdutoMarketplace!: DialogoProdutoMarketplace
	@Ref() dialogoDeEdicaoEmMassa!: DialogoDeEdicaoEmMassaProdutosMarketplace

	carregandoDadosMarketplace = false
	filtroDeLojas: any[] = []
	filtroSincronizar: boolean | null = true
	opcoesFiltroSincronizar = [
		{ text: 'Sincronizados', value: true },
		{ text: 'Não sincronizados', value: false },
	]
	headers = [
		{ text: 'Status Cad.', value: 'statusCadastro', sortable: false, width: '90px' },
		{ text: 'Sincronizar', value: 'sincronizar', sortable: false },
		{ text: 'Nome', value: 'nome', sortable: false },
		{ text: 'SKU', value: 'produto.sku', sortable: false },
		{ text: 'Descrição', value: 'descricao', sortable: false },
		{ text: 'Data Sinc.', value: 'dataHoraSincronizacaoDisplay', sortable: false },
		{ text: 'Status Sinc.', value: 'statusSincronizacao', sortable: false },
		{ text: 'Msg erro', value: 'msgErro', sortable: false, width: '90px' },
	]
	produtosMarketplace: ProdutoMarketplace[] = []
	lojaSelecionada: Loja | null = null
	mostrarDialogoDeProduto = false
	dadosDaLojaCarregada = false
	iniciandoSincronizacao = false
	executandoProcessoProdutos = false
	intervalId: number | null = null

	cancelToken: CancelTokenSource | null = null
	paginacao: DataOptions = {
		page: 1,
		itemsPerPage: 10,
		sortBy: [],
		sortDesc: [],
		groupBy: [],
		groupDesc: [],
		multiSort: false,
		mustSort: false,
	}
	totalRegistros = 0

	@Inject('LojaServiceAdapter')
	lojaService!: LojaServiceAdapter

	@Inject('MarketplaceServiceAdapter')
	marketplaceService!: MarketplaceServiceAdapter

	@Inject('ThreadsServiceAdapter')
	threadsService!: ThreadsServiceAdapter

	integracaoMarketplaceUseCase = new IntegracaoMarketplaceUseCase()


	get produtosMarketplaceFormatado() {
		return this.produtosMarketplace.map(produto => ({
			...produto,
			dataHoraSincronizacaoDisplay: this.diplayDataHora(produto),
		}))
	}

	getIconeStatusCadastro(status: 'COMPLETO' | 'INCOMPLETO' | 'VERIFICAR' | undefined): string {
		switch (status) {
			case 'COMPLETO': return 'mdi-check-circle'
			case 'VERIFICAR': return 'mdi-alert'
			default: return 'mdi-close-circle'
		}
	}

	getCorStatusCadastro(status: 'COMPLETO' | 'INCOMPLETO' | 'VERIFICAR' | undefined): string {
		switch (status) {
			case 'COMPLETO': return 'success'
			case 'VERIFICAR': return 'orange'
			default: return 'error'
		}
	}

	getTooltipStatusCadastro(item: ProdutoMarketplace): string {
		const label = this.getLabelStatusCadastro(item.statusCadastro)
		if (item.motivos && item.motivos.length > 0) {
			return `${label}: ${item.motivos.join('; ')}`
		}
		return label
	}

	getLabelStatusCadastro(status: 'COMPLETO' | 'INCOMPLETO' | 'VERIFICAR' | undefined): string {
		switch (status) {
			case 'COMPLETO': return 'Completo'
			case 'VERIFICAR': return 'Verificar'
			default: return 'Incompleto'
		}
	}

	mounted() {
		this.intervalId = setInterval(async () => {
			try {
				await this.recarregarStatusProcessoProdutos()
			} catch (error) {
				AlertModule.setError('Falha ao verificar andamento do processo de produtos')
			}
		}, 10000) as unknown as number
	}

	destroyed() {
		if (this.intervalId) {
			clearInterval(this.intervalId)
			this.intervalId = null
		}
	}

	diplayDataHora(produto: ProdutoMarketplace) {
		if (!produto.dataHoraSincronizacao) return 'NÃO SINCRONIZADO'
		return dateTimeToPtBrFormat(produto.dataHoraSincronizacao)
	}

	@Watch('filtroDeLojas')
	async aplicarFiltro() {
		this.carregandoDadosMarketplace = true
		try {
			if (typeof this.filtroDeLojas === 'string') {
				this.cancelToken = axios.CancelToken.source()
				const params: Record<string, unknown> = {
					page: this.paginacao.page - 1,
					size: this.paginacao.itemsPerPage,
				}
				if (this.filtroSincronizar !== null && this.filtroSincronizar !== undefined) {
					params.sincronizar = this.filtroSincronizar
				}

				const axiosConfig = {
					cancelToken: this.cancelToken.token,
				}

				const page = await this.marketplaceService.findAll(this.filtroDeLojas, params, axiosConfig)
				this.totalRegistros = page.totalElements
				this.produtosMarketplace = page.content.map(produto => {
					const verificacao = verificarQualidadeDoCadastro(produto)
					if (verificacao.completo === false) {
						produto.statusCadastro = 'INCOMPLETO'
						produto.motivos = verificacao.motivos
					} else if (verificacao.completo === true) {
						produto.statusCadastro = 'COMPLETO'
						produto.motivos = null
					} else {
						produto.statusCadastro = 'VERIFICAR'
						produto.motivos = verificacao.motivos
					}
					return produto
				})

				this.dadosDaLojaCarregada = true
				this.lojaSelecionada = await this.lojaService.get(this.filtroDeLojas)
			} else {
				this.dadosDaLojaCarregada = false
			}

		} catch (e) {
			AlertModule.setError(e)
		} finally {
			this.carregandoDadosMarketplace = false
		}
	}

	async aplicarFiltroSemLoading() {
		try {
			if (typeof this.filtroDeLojas === 'string') {
				this.cancelToken = axios.CancelToken.source()
				const params: Record<string, unknown> = {
					page: this.paginacao.page - 1,
					size: this.paginacao.itemsPerPage,
				}
				if (this.filtroSincronizar !== null && this.filtroSincronizar !== undefined) {
					params.exibirSincronizados = this.filtroSincronizar
				}

				const axiosConfig = {
					cancelToken: this.cancelToken.token,
				}

				const page = await this.marketplaceService.findAll(this.filtroDeLojas, params, axiosConfig)
				this.totalRegistros = page.totalElements
				this.produtosMarketplace = page.content.map(produto => {
					const verificacao = verificarQualidadeDoCadastro(produto)
					if (verificacao.completo === false) {
						produto.statusCadastro = 'INCOMPLETO'
						produto.motivos = verificacao.motivos
					} else if (verificacao.completo === true) {
						produto.statusCadastro = 'COMPLETO'
						produto.motivos = null
					} else {
						produto.statusCadastro = 'VERIFICAR'
						produto.motivos = verificacao.motivos
					}
					return produto
				})
				this.lojaSelecionada = await this.lojaService.get(this.filtroDeLojas)
			}
		} catch (e) {
			AlertModule.setError(e)
		}
	}

	async adicionarProduto() {
		if (!this.lojaSelecionada) return

		const produtoMarketplaceNovo = {
			id: '',
			loja: this.lojaSelecionada,
			nome: '',
			descricao: 'Sem descrição',
			produto: null,
			comprimento: null,
			peso: null,
			largura: null,
			altura: null,
			categoriaGlobal: null,
			unidade: null,
			origem: 'Nacional',
			genero: 'unissex',
			dataHoraSincronizacao: null,
			atributos: [],
			canaisVenda: [],
			videos: [],
			sincronizar: true,
			tabelaDePreco: null,
			dadosAdicionais: null,
			statusSincronizacao: 'Pendente',
			idAnuncioMercadoLivre: null,
			variantes: [],
			imagens: null,
			msgErro: null,
			statusCadastro: 'INCOMPLETO',
			motivos: null,
		} as ProdutoMarketplace

		this.dialogoProdutoMarketplace.mostrar(produtoMarketplaceNovo, this.lojaSelecionada)
	}
	
	editarProduto(indice: any) {
		if (!this.lojaSelecionada) return
		const produtoMarketplace = this.produtosMarketplace[indice]

		this.dialogoProdutoMarketplace.mostrar(produtoMarketplace, this.lojaSelecionada)
	}

	atualizarLista(produto: ProdutoMarketplace) {
		const indice = this.produtosMarketplace.findIndex(produtoFilter => produtoFilter.id === produto.id)

		if (indice >= 0) {
			this.produtosMarketplace.splice(indice, 1, produto)
		} else {
			this.produtosMarketplace.push(produto)
		}
	}

	async sincronizarProdutosConfigurados() {
		if(!this.lojaSelecionada) return

		try {
			this.iniciandoSincronizacao = true
			await this.integracaoMarketplaceUseCase.integrarProdutos(this.lojaSelecionada.id)
			await this.recarregarStatusProcessoProdutos()
			AlertModule.setSuccess('Sincronização iniciada')
		} catch (error) {
			AlertModule.setError(error)
		} finally {
			this.iniciandoSincronizacao = false
		}
	}

	async recarregarStatusProcessoProdutos() {
		if (!this.lojaSelecionada) return

		this.cancelToken = axios.CancelToken.source()
		const params = {
			nomeThread: 'AsyncThread-IntegrarProdutosPlug4market-'+this.lojaSelecionada.id,
		}

		const axiosConfig = {
			cancelToken: this.cancelToken.token,
		}

		const threads = await this.threadsService.findAll(params, axiosConfig)

		if (threads.length > 0) {
			this.executandoProcessoProdutos = threads.map(thread => thread.state).includes('RUNNABLE')
		} else {
			this.executandoProcessoProdutos = false
		}

		if (!this.executandoProcessoProdutos) this.aplicarFiltroSemLoading()
	}

	async recarregar() {
		await this.aplicarFiltro()
	}

	async atualizarSincronizacaoProduto(indice: any, sincronizar: boolean) {
		try {
			this.marketplaceService.atualizarSincronizacaoProduto(this.produtosMarketplace[indice].id, sincronizar)
		} catch (error) {
			AlertModule.setError(error)
		}
	}
	
	@Watch('paginacao', { deep: true })
	onChangePaginacao() {
		this.aplicarFiltro()
	}

	@Watch('filtroSincronizar')
	onChangeFiltroSincronizar() {
		if (typeof this.filtroDeLojas !== 'string') return
		this.paginacao = { ...this.paginacao, page: 1 }
	}
}
